const education = [
    {   
        companyIcon: 'facisa.png', 
        role: 'Associates Degree in Digital Games', 
        companyName: 'Unifacisa - Centro Universitário ', 
        companyLocation: 'Paraíba, Brazil', 
        year: 'February 2016 - July 2020'
    },
    { 
        companyIcon: 'if.png', 
        role: 'Secondary Technical Education in Maintenance and Support in IT', 
        companyName: 'Instituto Federal de Educação, Ciência e Tecnologia ', 
        companyLocation: 'Paraíba, Brazil', 
        year: 'February 2009 - July 2013'
    },
    
  ];
  
  export default education;